import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Text } from 'foundations-components/components/Text';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Flex } from 'foundations-components/components/Flex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import useDebounce from '../../hooks/useDebounce';
import { useOneTimePassword, TEMPLATE_MAP } from './useOneTimePassword';
import { simpleAction } from '../../actions/utils';
import { useQueryData } from '../../hooks/useQueryData';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OneTimePasswordComponent = props => {
  const {
    history
  } = props;
  const {
    allQueryParams
  } = useQueryData();
  const {
    otp,
    otpId,
    userId,
    next,
    template
  } = allQueryParams;
  const dispatch = useDispatch();
  const {
    isLoading,
    responseLanguageKey,
    onLoad,
    resendHandler,
    showActionButton,
    isError,
    templateLanguageKey,
    isLoginLoading,
    setIsLoginLoading
  } = useOneTimePassword({
    otp,
    otpId,
    next,
    template,
    userId
  });
  const returnToLogin = () => {
    dispatch(simpleAction('CLICKED_BACK_BUTTON'));
    history.push('/');
  };
  const debouncedOnLoad = useDebounce(onLoad, 1000);
  const handleClick = useCallback(() => {
    setIsLoginLoading(true);
    debouncedOnLoad();
  }, [debouncedOnLoad, setIsLoginLoading]);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "center",
    blockSize: "90vh",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "OTP_PAGE_LOAD"
    }), isLoading ? /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h1",
        marginBlockEnd: "600",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.otp.header"
        })
      }), /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.otp.description"
        })
      }), /*#__PURE__*/_jsx(LoadingButton, {
        onClick: handleClick,
        use: "primary",
        loading: isLoginLoading,
        disabled: isLoginLoading,
        marginBlockStart: "1000",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.otp.button"
        })
      })]
    }) : /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "column",
      children: [isError && /*#__PURE__*/_jsx(Illustration, {
        name: "empty-state-charts",
        width: "350px"
      }), /*#__PURE__*/_jsx(Text, {
        as: "h1",
        marginBlock: "400",
        textAlign: "center",
        children: responseLanguageKey && /*#__PURE__*/_jsx(FormattedMessage, {
          message: `login.otp.${templateLanguageKey}.${responseLanguageKey}.title`
        })
      }), /*#__PURE__*/_jsx("div", {
        children: responseLanguageKey && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `login.otp.${templateLanguageKey}.${responseLanguageKey}.body`
        })
      }), /*#__PURE__*/_jsx("div", {
        children: showActionButton && /*#__PURE__*/_jsx(Button, {
          use: "primary",
          marginBlockStart: "1000",
          onClick: template === TEMPLATE_MAP.DEFAULT_LOGIN ? returnToLogin : resendHandler,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: template === TEMPLATE_MAP.DEFAULT_LOGIN ? 'login.otp.loginReturn' : `login.otp.${templateLanguageKey}.expired.button`
          })
        })
      })]
    })]
  });
};
export default OneTimePasswordComponent;